import fetch from './fetch';
import utils from '../utils';

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/treeByCode', keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

export default {
    querySearch
}